import { tr } from 'mmfintech-commons'
import { PaymentMethods, useCheckoutPolling, useEventTracker } from 'mmfintech-checkout-commons'
import { CoreButton } from '../../../components'
import type {
  BaseInstructionsResult,
  FawryPayInstructionsResult,
  FlutterwaveMobileAppInstructionsResult,
  PaymentSessionData
} from 'mmfintech-checkout-commons/types'

import './PreviewInstructions.scss'

interface PreviewInstructionsProps {
  result: BaseInstructionsResult
  session?: PaymentSessionData
  sessionId?: string
}

export const PreviewInstructions = ({ result, session, sessionId }: PreviewInstructionsProps) => {
  const { successUrl } = session || {}
  const { paymentMethod } = result || {}

  const { startPolling } = useCheckoutPolling({
    sessionId,
    pollingInterval: 5000,
    maxPollCount: 60
  })

  const { trackEvent } = useEventTracker()

  const handleRedirect = () => {
    void trackEvent(sessionId, 'redirected_back_to_merchant')
    window.location.href = successUrl
  }

  const RedirectButton = () =>
    successUrl ? (
      <div className='buttons'>
        <CoreButton
          type='button'
          variation='primary'
          onClick={handleRedirect}
          text={tr('CHECKOUT.BUTTONS.CLOSE', 'Close')}
          data-test='button-back'
        />
      </div>
    ) : null

  if (paymentMethod === PaymentMethods.FAWRY_PAY) {
    const { instructions } = (result as FawryPayInstructionsResult) || {}
    return (
      <>
        <div className='preview-instructions-wrapper'>{instructions}</div>
        <RedirectButton />
      </>
    )
  }

  if (paymentMethod === PaymentMethods.M_PESA) {
    startPolling()
    const { phoneNumber } = (result as FlutterwaveMobileAppInstructionsResult) || {}
    return (
      <>
        <div className='preview-instructions-wrapper'>
          {tr(
            'CHECKOUT.INSTRUCTIONS.MPESA',
            'You will receive a prompt on mobile number {{phone_number}} to enter your MPESA service PIN to authorize your payment request.',
            { phone_number: phoneNumber }
          )}
        </div>
        <RedirectButton />
      </>
    )
  }

  if (paymentMethod === PaymentMethods.MOBILE_MONEY) {
    startPolling()
    const { phoneNumber } = (result as FlutterwaveMobileAppInstructionsResult) || {}
    return (
      <>
        <div className='preview-instructions-wrapper'>
          {tr(
            'CHECKOUT.INSTRUCTIONS.MOBILE_MONEY',
            'You will receive a prompt on mobile number {{phone_number}} to enter your Mobile Money service PIN to authorize your payment request.',
            { phone_number: phoneNumber }
          )}
        </div>
        <RedirectButton />
      </>
    )
  }

  return null
}
